export const Marquee = ({ text, speed = 38 }) => (
  <div className="cp-marquee" data-testid="editorial-marquee">
    <div className="cp-marquee-track" style={{ animationDuration: `${speed}s` }}>
      <span>{text}</span>
      <span>{text}</span>
    </div>
  </div>
);
